export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/book_editing.d70e7bc.svg";